module.exports = __webpack_public_path__ + "static/media/loader.9a826352.gif";